import { FormItem } from "./imis.models";

export interface CustomValidatorOptions {
    id: string;
    text: string;
    evaluationFunction: () => boolean;
    validationGroup?: string;
    triggerValidation?: boolean;
}

export class FormDragDrop {
    data: FormItem;
    layoutRows: FormLayoutColumn[][];
    jHtml: JQuery;

    constructor(formItem: FormItem) {
        this.data = formItem;
        this.layoutRows = [];
        this.jHtml = jQuery(`<div>${formItem.FormHtmlCode}</div>`);
    }

    updateLayout() {
        let layoutIdentifiers: string[] = [];
        for (let i = 0; i < this.layoutRows.length; i++) {
            for (let j = 0; j < this.layoutRows[i].length; j++) {
                let column = this.layoutRows[i][j];
                let identifier = this.getLayoutIdentifier(i + 1, j + 1, column.width);
                layoutIdentifiers.push(identifier);
            }
        }

        let layoutIdentifiersText = layoutIdentifiers.join(",");
        this.jHtml.find("layout").text(layoutIdentifiersText);
        this.data.FormHtmlCode = this.getFormHtml();
    }

    getLayoutIdentifier(row: number, column: number, width: number): string {
        return `R${row}C${column}W${width}`;
    }

    getFormHtml(): string {
        return this.jHtml.html();
    }
}

export class FormLayoutColumn {
    width: number;
    jHtml: JQuery;
}
